import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import SegmentController from 'cio/pods/segments/segment/controller';
import SegmentOverviewController from 'cio/pods/segments/segment/overview/controller';
import FiltersService from 'cio/services/filters';
import SegmentModel from 'cio/models/segment';
import Transition from '@ember/routing/-private/transition';

export default class OverviewRoute extends Route {
  @service filters!: FiltersService;

  model() {
    return this.modelFor('segments.segment');
  }

  afterModel() {
    return this.filters.process.perform();
  }

  setupController(controller: SegmentOverviewController, model: SegmentModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.fetchAudiences.perform();
  }

  activate() {
    super.activate();

    (this.controllerFor('segments.segment') as SegmentController).fetchImports.perform();
  }
}
